module.exports = new __parcel__URL__("roadmap-light.7a029252.svg").toString();